export const PROFILE = {
  name: "Kaarthik Rishaanth",
  pronouns: "He/Him",
  title: "Computer Science Undergraduate (9.11 CGPA | Dept Topper) specializing in Java Backend, Application Security, and Cloud Infrastructure.",
  tagline: "Student | Full Stack Developer | Java | Python | Android | Cloud & Security | SIH 2024 Finalist",
  email: "rishaanthkaarthik@gmail.com",
  linkedin: "https://www.linkedin.com/in/kaarthik-rishaanth/",
  github: "https://github.com/Rishcoden",
  school: "Dr. N.G.P. Institute of Technology, Coimbatore, Tamil Nadu, India"
};

export const PROJECTS = [
  // -------------------------------------------------------------
  // NEW ADDITIONS FROM RESUME
  // -------------------------------------------------------------
  {
    id: 'smsfilter',
    name: 'SMSFilter — AI-Powered SMS Classifier with Link Scanner',
    description:
      'An Android security app that uses an offline ONNX AI model to classify incoming SMS messages as Spam or Verified in real time with 0ms network latency. Integrated with K Web Secure Scanner middleware to scan URLs, verify SSL certificates, and query VirusTotal API endpoints for malware detection.',
    screenshots: ['/screenshots/ksms.mp4'],
    startDate: '2026-01-01',
    endDate: '2026-03-30',
    features: [
      'Offline ONNX AI model for real-time SMS spam classification',
      'Zero-latency threat detection without requiring internet access',
      'Integrated link scanner middleware to intercept incoming URLs',
      'SSL certificate verification and VirusTotal API integration',
      'Displays real-time threat alerts before opening risky links'
    ],
    github: 'https://www.linkedin.com/posts/kaarthik-rishaanth_androiddevelopment-cybersecurity-ai-ugcPost-7426122718418198528-I1Fw/?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAAE768gkBiIoQy-tlv2ZF6DvptarZ7p7KMAM',
    tags: ['Android', 'Java', 'ONNX Runtime', 'VirusTotal API', 'AI/ML', 'Security'],
    highlight: true
  },

  {
    id: 'dreamdart',
    name: 'DreamDart — Coding Practice Platform',
    description:
      'Full-stack online coding assessment platform handling frontend, backend, and database architecture end-to-end. Features user authentication, problem submission evaluation workflows, and real-time user progress tracking. Deployed on a Linux VPS with custom Nginx reverse proxy configuration.',
    screenshots: ['/screenshots/d1.png', '/screenshots/d2.png', '/screenshots/d3.png', '/screenshots/d4.png', '/screenshots/d5.png', '/screenshots/d7.png'],
    startDate: '2025-01-01',
    endDate: '2025-05-30',
    features: [
      'Online coding and problem evaluation portal',
      'User authentication, problem listings, and submission tracking',
      'Scalable data models built on Firestore',
      'Deployed on Linux VPS with Nginx production setup'
    ],
    github: 'https://www.linkedin.com/posts/kaarthik-rishaanth_reactjs-firebase-supabase-ugcPost-7421531546257444864-LUND/?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAAE768gkBiIoQy-tlv2ZF6DvptarZ7p7KMAM',
    tags: ['Java', 'React', 'Firestore', 'Linux', 'VPS', 'REST APIs', 'Full Stack'],
    highlight: true
  },


  // -------------------------------------------------------------
  // EXISTING PROJECTS FROM YOUR FILE
  // -------------------------------------------------------------
  {
    id: 'secureapk',
    name: 'SecureApk (SIH Finals – IIT Jammu)',
    description:
      'SecureApk is an advanced reverse-engineering and security enhancement portal developed for NCIIPC as part of the Smart India Hackathon (SIH) Finals held at IIT Jammu. The platform allows users to upload APK files, which are decoded using APKTool and processed to extract and modify DEX/Smali code.',
    screenshots: [
      '/screenshots/30.jpeg',
      '/screenshots/31.jpeg',
      '/screenshots/32.png',
      '/screenshots/33.png'
    ],
    startDate: '2024-09-01',
    endDate: '2024-12-31',
    features: [
      'APK uploading and decoding using APKTool',
      'DEX to Smali conversion and reinjection',
      'Injects security code to block screenshots',
      'Disables sensitive permissions (Wi-Fi, GPS, Bluetooth, Camera, etc.)'
    ],
    github: 'https://github.com/Rishcoden/Sih',
    tags: ['Reverse-Engineering', 'Cyber', 'APKTool', 'Smali', 'DEX', 'Python', 'Security', 'SIH Finalist'],
    highlight: true
  },
  {
    id: 'crackerhub',
    name: 'CrackerHub — Inventory & Billing System',
    description:
      'Real-time inventory and billing application for multi-branch retail stores. Features role-based access control (RBAC) for admins and staff, managing live stock synchronization and automated invoice generation.',
    screenshots: ['/screenshots/crackers.mp4'],
    startDate: '2024-05-01',
    endDate: '2024-08-31',
    features: [
      'Multi-branch real-time stock and inventory synchronization',
      'Role-based access control (RBAC) for Admin and Cashier roles',
      'Real-time bill generation using Firestore listener hooks'
    ],
    github: 'https://www.linkedin.com/posts/kaarthik-rishaanth_ngpit-ngpabrkaarthikrishaanth-react-activity-7259215075478016001-EdRs?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAAE768gkBiIoQy-tlv2ZF6DvptarZ7p7KMAM',
    tags: ['React Native', 'Firebase Firestore', 'Mobile App', 'System Design']
  },
  {
    id: 'siteravempmx',
    name: 'SiteraveMPMX — Secure Online Exam Portal',
    description:
      'SiteraveMPMX is a secure online examination portal built to prevent cheating during tests. It restricts copy-pasting, tab switching, and iframe escapes, hardened against directory enumeration tools like Gobuster.',
    screenshots: ['/screenshots/5.mp4'],
    startDate: '2025-02-01',
    endDate: '2025-02-28',
    features: [
      'Blocks copy, paste, and tab switching during active exams',
      'Disables developer tools and right-click context menus',
      'Protects against directory brute-forcing using Node.js backend logic'
    ],
    github: 'https://github.com/Rishcoden/coderevempx',
    tags: ['React JS', 'Material UI', 'Node.js', 'Security', 'Exam Portal']
  },
  {
    id: 'ksecure',
    name: 'KSecure',
    description:
      'KSecure is a cybersecurity-focused mobile application designed to scan malicious APK files and local files. It includes utilities such as root checker, USB debugging status detector, and developer options monitor via VirusTotal API.',
    screenshots: ['/screenshots/11.jpg', '/screenshots/12.jpg'],
    startDate: '2025-01-01',
    endDate: '2025-03-01',
    features: [
      'Scan APK files for malware using VirusTotal API',
      'Root detection and USB debugging status checker'
    ],
    github: 'https://github.com/Rishcoden/KSecure',
    tags: ['Android', 'XML', 'VirusTotal API', 'Cybersecurity', 'ADB']
  },
  {
    id: 'crime-hotspot',
    name: 'Crime Hotspot Detection',
    description:
      'An AI/ML-based web dashboard that predicts future crime hotspots using historical crime data and Random Forest models.',
    screenshots: ['/screenshots/21.png', '/screenshots/22.png'],
    startDate: '2025-01-01',
    endDate: '2025-04-30',
    features: [
      'Predicts crime zones using Random Forest algorithm',
      'Interactive satellite map views using Leaflet'
    ],
    github: 'https://github.com/Rishcoden/crime-hotspot-dashboard',
    tags: ['RandomForest', 'Next.js', 'AI/ML', 'Leaflet']
  },
  {
    id: 'vivnovation-audit',
    name: 'Vivnovation Security Audit (White-Hat)',
    description:
      'White-hat cybersecurity audit conducted on Vivnovation website to identify hidden directories, open ports, and SSL vulnerabilities using Gobuster and Nmap.',
    screenshots: ['/screenshots/80.png', '/screenshots/81.png'],
    startDate: '2025-07-04',
    endDate: '2025-07-08',
    features: [
      'Scanned hidden directories via Gobuster',
      'Conducted port scanning via Nmap'
    ],
    github: '',
    tags: ['Cyber', 'Gobuster', 'Nmap', 'Security Audit', 'Ethical Hacking']
  },
  {
    id: 'lawassistant',
    name: 'LawAssistant',
    description:
      'Educational chatbot app designed to guide users through Indian legal scenarios and assist with complaint registration via Firebase.',
    screenshots: ['/screenshots/61.jpg', '/screenshots/62.jpg'],
    startDate: '2024-10-01',
    endDate: '2025-02-28',
    features: ['Conversational legal chatbot', 'Firebase real-time sync'],
    github: 'https://github.com/Rishcoden/LawAssist',
    tags: ['Android Studio', 'Firebase', 'Chatbot', 'Legal Tech']
  },
  {
    id: 'kresolver',
    name: 'KResolver App',
    description:
      'Utility Android app designed to bypass YouTube update warnings on legacy Android 7 devices using ADB root shell commands.',
    screenshots: ['/screenshots/4.mp4'],
    startDate: '2025-01-01',
    endDate: '2025-01-30',
    features: ['Fixes YouTube warning issue on Android 7 via root shell ADB commands'],
    github: 'https://github.com/Rishcoden/KResolver',
    tags: ['Android Studio', 'ADB', 'RootShell', 'System Tools']
  },
  {
    id: 'kpowercare',
    name: 'KPowerCare',
    description:
      'Battery-saving Android utility optimizing performance by controlling hardware modules and background location tracking.',
    screenshots: ['/screenshots/71.jpg', '/screenshots/72.jpg'],
    startDate: '2023-09-01',
    endDate: '2023-12-31',
    features: ['One-tap battery saver toggles and scheduled optimization'],
    github: 'https://github.com/Rishcoden/kpowercare_2.0',
    tags: ['Android Studio', 'ADB', 'Java', 'Battery Saver']
  }
];